import {GetChatRoom} from 'domain/usecases';
import {RemoteGetChatRoom} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {ExternalLinkPoint} from 'main/factories/usecases/endpoints';

export const makeGetChatRoom = (isV2?: boolean): GetChatRoom =>
	new RemoteGetChatRoom(
		makeBFFApiUrl(isV2 ? ExternalLinkPoint.chatRoomv2 : ExternalLinkPoint.chatRoom),
		makeAuthorizeHttpClientDecorator(),
	);
